import Grid from '@mui/material/Grid'
import { openUrl } from 'helpers/global.helper/global.helper'
import i18n from 'i18next'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'ui/atoms'
import Title from 'ui/molecules/Title/Title'
import { registerDefaultProps, registerUiConfigComponent } from 'ui/uiConfig/factory'
import styles from './ReferenceGuides.module.less'
import type { ReferenceGuidesProps } from './ReferenceGuides.types'

const defaultProps: Omit<ReferenceGuidesProps, 'datasets' | 'children'> = {
  guides: [
    {
      title: 'Guide 1',
      url: 'https://veryimportantnottoforgethttpsinbeginning.xyz',
      content: 'In this field you can write a short summary about the quick reference guide.',
    },
  ],
}

registerUiConfigComponent('reference_guides', ReferenceGuides, {
  isSingletonComponent: true,
  title: i18n.t('Reference guides'),
})
registerDefaultProps('reference_guides', defaultProps)

export default function ReferenceGuides({ guides }: ReferenceGuidesProps): ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <Grid container>
        {guides.map((guide, index) => (
          <Grid key={index} size={{ xs: 12, md: 6 }}>
            <div className={styles.ReferenceGuides_Guide}>
              <Title size={'medium'} title={guide.title} />
              <div className={styles.ReferenceGuides_Content}>{guide.content}</div>
              <Button primary onClick={() => openUrl(guide.url)}>
                {t('Open reference guide')}
              </Button>
            </div>
          </Grid>
        ))}
      </Grid>
    </>
  )
}
